(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hepalune-orthotic-product"] && !Shopify.designMode) return;
  try {
    
  const initHepaluneOrthotic = (root) => {
    if (root.dataset.hpoReady === 'true') return;
    root.dataset.hpoReady = 'true';
    const demoImage = root.querySelector('[data-hpo-demo-image]');
    const demoSource = root.querySelector('[data-hpo-demo-source]');
    const demoToggle = root.querySelector('[data-hpo-demo-toggle]');
    if (demoImage && demoToggle) {
      let demoPlaying = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const updateDemo = () => {
        const src = demoPlaying ? demoImage.dataset.animation : demoImage.dataset.poster;
        demoImage.src = src;
        if (demoSource) demoSource.srcset = src;
        demoToggle.dataset.paused = String(!demoPlaying);
        demoToggle.querySelector('[data-hpo-demo-label]').textContent = demoPlaying ? demoToggle.dataset.pauseLabel : demoToggle.dataset.playLabel;
      };
      demoToggle.hidden = false;
      demoToggle.addEventListener('click', () => {
        demoPlaying = !demoPlaying;
        updateDemo();
      });
      window.addEventListener('pageshow', () => {
        if (demoPlaying && demoImage.currentSrc !== demoImage.dataset.animation) updateDemo();
      });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && demoPlaying) updateDemo();
      });
      updateDemo();
    }

    const variantData = root.querySelector('[data-hpo-variants]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const variantInput = root.querySelector('[data-hpo-variant-id]');
    const addButton = root.querySelector('[data-hpo-add]');
    const stickyButton = root.querySelector('[data-hpo-sticky-add]');
    const mainAddButton = root.querySelector('[data-hpo-add]');
    const sticky = root.querySelector('[data-hpo-sticky]');
    let activeVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0];
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: root.dataset.currency || 'USD'
    }).format(cents / 100);
    const discountedBundleTotal = (price, quantity, discount) => Math.round(price * quantity * (100 - discount) / 100);

    const refreshBundlePrices = () => {
      if (!activeVariant) return;
      root.querySelectorAll('[data-hpo-quantity-choice]').forEach((control) => {
        const quantity = Number(control.value);
        const discount = Number(control.dataset.discount || 0);
        control.dataset.bundleTotal = formatMoney(discountedBundleTotal(activeVariant.price, quantity, discount));
      });
      root.querySelectorAll('[data-hpo-bundle-total]').forEach((node) => {
        const quantity = Number(node.dataset.quantity || 1);
        const discount = Number(node.dataset.discount || 0);
        node.textContent = formatMoney(discountedBundleTotal(activeVariant.price, quantity, discount));
      });
      root.querySelectorAll('[data-hpo-bundle-unit]').forEach((node) => {
        const quantity = Number(node.dataset.quantity || 1);
        const discount = Number(node.dataset.discount || 0);
        const total = discountedBundleTotal(activeVariant.price, quantity, discount);
        node.textContent = `${formatMoney(Math.round(total / quantity))} / pair`;
      });
      root.querySelectorAll('[data-hpo-bundle-original]').forEach((node) => {
        node.textContent = formatMoney(activeVariant.price * Number(node.dataset.quantity || 1));
      });
    };

    const selectedOptions = () => {
      const values = [];
      root.querySelectorAll('[data-hpo-option-control]').forEach((control) => {
        if (control.type === 'hidden' || control.checked) values[Number(control.dataset.optionPosition)] = control.value;
      });
      return values;
    };

    const refreshBundleSelection = () => {
      const selectedBundle = root.querySelector('[data-hpo-quantity-choice]:checked');
      if (!selectedBundle) return;
      root.querySelectorAll('[data-hpo-cta-price]').forEach((node) => {
        node.textContent = selectedBundle.dataset.bundleTotal || '';
      });
    };

    const refreshVariant = () => {
      const options = selectedOptions();
      activeVariant = variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      if (variantInput) {
        const variantId = activeVariant?.id || '';
        variantInput.value = variantId;
        variantInput.setAttribute('value', variantId);
      }
      root.querySelectorAll('[data-hpo-price]').forEach((node) => {
        node.textContent = activeVariant?.priceFormatted || '';
      });
      const available = Boolean(activeVariant?.available);
      if (addButton) {
        addButton.disabled = !available;
        const label = addButton.querySelector('[data-hpo-add-label]');
        if (label) label.textContent = activeVariant ? (available ? addButton.dataset.addText : addButton.dataset.soldText) : addButton.dataset.unavailableText;
        const price = addButton.querySelector('[data-hpo-cta-price]');
        if (price) price.hidden = !available;
      }
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = activeVariant ? (available ? addButton.dataset.addText : addButton.dataset.soldText) : addButton.dataset.unavailableText;
      }
      refreshBundlePrices();
      refreshBundleSelection();
      const url = new URL(window.location.href);
      if (activeVariant?.id) url.searchParams.set('variant', String(activeVariant.id).split('/').pop());
      window.history.replaceState({}, '', url);
    };

    root.querySelectorAll('[data-hpo-option-control]').forEach((control) => control.addEventListener('change', refreshVariant));
    root.querySelectorAll('[data-hpo-quantity-choice]').forEach((control) => {
      control.addEventListener('change', () => {
        refreshBundleSelection();
      });
    });

    root.querySelectorAll('[data-hpo-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = root.querySelector(`#${CSS.escape(thumb.dataset.target)}`);
        if (!target) return;
        const gallery = root.querySelector('[data-hpo-gallery]');
        if (!gallery) return;
        const left = gallery.scrollLeft + target.getBoundingClientRect().left - gallery.getBoundingClientRect().left - gallery.clientLeft;
        gallery.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        root.querySelectorAll('[data-hpo-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    const gallery = root.querySelector('[data-hpo-gallery]');
    if (gallery) {
      gallery.addEventListener('scrollend', () => {
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        root.querySelectorAll('[data-hpo-thumb]').forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', index === thumbIndex));
      });
    }

    if (mainAddButton && sticky) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || window.scrollY < 500;
      }, { threshold: 0.1 });
      observer.observe(mainAddButton);
    }

    refreshVariant();
  };

  document.querySelectorAll('[data-hpo-root]').forEach(initHepaluneOrthotic);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-hpo-root]').forEach(initHepaluneOrthotic);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stillora-product-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fields = `id checkoutUrl totalQuantity
    cost { subtotalAmount { amount currencyCode } }
    lines(first:50) { nodes { id quantity attributes { key value }
      merchandise { ... on ProductVariant { id } }
      cost { totalAmount { amount currencyCode } }
      ... on ComponentizableCartLine { lineComponents { quantity merchandise { ... on ProductVariant { id } } } }
    } pageInfo { hasNextPage } }`;
  const operations = {
    read: `query StilloraCart($id:ID!) { cart(id:$id) { ${fields} } }`,
    create: `mutation StilloraCartCreate($input:CartInput!) { cartCreate(input:$input) { cart { ${fields} } userErrors { message code } } }`,
    add: `mutation StilloraCartAdd($id:ID!,$lines:[CartLineInput!]!) { cartLinesAdd(cartId:$id,lines:$lines) { cart { ${fields} } userErrors { message code } } }`,
    remove: `mutation StilloraCartRemove($id:ID!,$lines:[ID!]!) { cartLinesRemove(cartId:$id,lineIds:$lines) { cart { ${fields} } userErrors { message code } } }`
  };

  window.StilloraCart = class {
    constructor(config) {
      this.config = config;
      this.cart = null;
      this.storageKey = 'stillora-us-cart-v1';
      this.id = null;
      try { this.id = sessionStorage.getItem(this.storageKey); } catch (_) { /* Storage is optional. */ }
    }
    async request(name, variables) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.config.product.storeUrl + '/api/2026-07/graphql.json', {
          method: 'POST', headers: {'Content-Type':'application/json'},
          body: JSON.stringify({query: operations[name], variables}), signal: controller.signal
        });
        if (!response.ok) throw new Error('Your cart could not be updated. Please try again.');
        const body = await response.json();
        if (body.errors?.length) throw new Error('Your cart could not be updated. Please try again.');
        const payload = body.data?.[{read:'cart',create:'cartCreate',add:'cartLinesAdd',remove:'cartLinesRemove'}[name]];
        if (name !== 'read' && payload?.userErrors?.length) throw new Error(payload.userErrors[0].message);
        const cart = name === 'read' ? payload : payload?.cart;
        if (name !== 'read' && !cart) throw new Error('Your cart could not be updated. Please try again.');
        this.cart = cart || null;
        this.id = cart?.id || null;
        try {
          if (this.id) sessionStorage.setItem(this.storageKey, this.id);
          else sessionStorage.removeItem(this.storageKey);
        } catch (_) { /* A cart still works when session storage is unavailable. */ }
        return this.cart;
      } finally { clearTimeout(timeout); }
    }
    async load() {
      if (!this.id) return null;
      return this.request('read', {id:this.id});
    }
    managedLines() {
      return (this.cart?.lines.nodes || []).filter(line => line.attributes.some(a => a.key === '_stillora_offer' && a.value === 'us-v1'));
    }
    currentOffer() {
      const ids = this.managedLines().map(line => line.merchandise.id);
      return Object.values(this.config.offers).find(offer => ids.includes(offer.variantId)) || null;
    }
    lineInputs(offer) {
      const attributes = [{key:'_stillora_offer',value:'us-v1'}];
      const lines = [{merchandiseId:offer.variantId,quantity:1,attributes}];
      if (offer.quantity === 3) lines.push({merchandiseId:this.config.gift.variantId,quantity:1,attributes});
      return lines;
    }
    confirmed(offer) {
      if (!this.cart || this.cart.lines.pageInfo.hasNextPage) return false;
      const lines = this.managedLines();
      const parent = lines.find(line => line.merchandise.id === offer.variantId);
      const gift = lines.find(line => line.merchandise.id === this.config.gift.variantId);
      const matchesPrice = line => line?.cost.totalAmount.currencyCode === 'USD' && Math.round(Number(line.cost.totalAmount.amount)*100) === offer.priceCents;
      if (parent?.quantity !== 1 || !matchesPrice(parent)) return false;
      if (offer.quantity > 1) {
        const magnesium = parent.lineComponents?.find(line => line.merchandise.id === this.config.offers[1].variantId);
        if (magnesium?.quantity !== offer.quantity) return false;
      }
      if (offer.quantity === 3) return lines.length === 2 && gift?.quantity === 1 && gift.cost.totalAmount.currencyCode === 'USD' && Number(gift.cost.totalAmount.amount) === 0;
      return lines.length === 1 && !gift;
    }
    async setOffer(offer) {
      // Keep one selected offer. Replace only the lines owned by this selector.
      await this.load();
      if (this.confirmed(offer)) return this.cart;
      if (this.cart?.lines.pageInfo.hasNextPage) throw new Error('Please finish your current cart before adding this bundle.');
      const owned = this.managedLines();
      if (owned.length) await this.request('remove', {id:this.id,lines:owned.map(line => line.id)});
      if (this.id) await this.request('add', {id:this.id,lines:this.lineInputs(offer)});
      else await this.request('create', {input:{buyerIdentity:{countryCode:'US'},lines:this.lineInputs(offer)}});
      if (!this.confirmed(offer)) throw new Error('Your bundle price could not be confirmed. Please try again.');
      return this.cart;
    }
    async remove() {
      await this.load();
      const owned = this.managedLines();
      if (owned.length) await this.request('remove', {id:this.id,lines:owned.map(line => line.id)});
      return this.cart;
    }
  };
})();

(() => {
  const root = document.querySelector('.stillora-page');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const native = document.querySelector('.stillora-native-config');
  const config = window.STILLORA_CONTENT || {
    product: { currency: 'USD', storeUrl: native.dataset.store },
    offers: {"1": {"quantity": 1, "title": "1 Bottle · 30-Day Supply", "priceCents": 2945, "shippingCents": 699, "guarantee": "30-day money-back guarantee", "variantId": "gid://shopify/ProductVariant/63535369093450", "compareAtCents": 3800}, "2": {"quantity": 2, "title": "2 Bottles · 60-Day Supply", "priceCents": 4926, "shippingCents": 0, "guarantee": "60-day money-back guarantee", "variantId": "gid://shopify/ProductVariant/63537984667978", "compareAtCents": 5500}, "3": {"quantity": 3, "title": "3 Bottles + FREE Gift", "priceCents": 5692, "shippingCents": 0, "guarantee": "90-day money-back guarantee", "variantId": "gid://shopify/ProductVariant/63537985782090", "compareAtCents": 11100}},
    gift: { variantId: 'gid://shopify/ProductVariant/63535368864074' },
    survey: { sampleSize: document.getElementById('survey-sample').textContent, period: document.getElementById('survey-period').textContent }, policies: {}
  };
  if (native) {
    document.querySelectorAll('[data-native-result]').forEach(column => {
      const raw = column.dataset.percentage.trim();
      const value = /^(?:100(?:\.0+)?|[0-9]{1,2}(?:\.[0-9]+)?)$/.test(raw) ? Number(raw) : null;
      config.survey[column.dataset.result] = { percentage: value, outcome: column.querySelector('h3').textContent, supporting: column.querySelector('.result-support').textContent };
    });
    const customHero = document.querySelector('#main-product-image');
    const firstThumb = document.querySelector('.gallery-thumb');
    firstThumb.dataset.image = customHero.currentSrc || customHero.src;
    firstThumb.querySelector('img').src = customHero.currentSrc || customHero.src;
  }
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const money = amount => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  let selected = 2;
  let cartBusy = false;
  const bundleCart = new window.StilloraCart(config);
  const all = (selector, within = document) => [...within.querySelectorAll(selector)];
  const say = text => { document.getElementById('live-status').textContent = text; };
  all('[data-policy]').forEach(a => { if (config.policies[a.dataset.policy]) a.href = config.policies[a.dataset.policy]; });
  document.getElementById('current-year').textContent = new Date().getFullYear();
  function setOfferImage(image, offer) {
    const source = document.getElementById('closing-product-image');
    const url = source.getAttribute('data-image-' + offer.quantity);
    if (image.getAttribute('src') !== url) image.src = url;
    image.alt = source.dataset.productName + ' — ' + offer.title;
  }
  function updateBundle() {
    all('[data-bundle-price]').forEach(el => el.textContent = money(config.offers[el.dataset.bundlePrice].priceCents / 100));
    all('[data-bundle-compare]').forEach(el => el.textContent = money(config.offers[el.dataset.bundleCompare].compareAtCents / 100));
    all('.button-price').forEach(el => el.textContent = '— ' + money(config.offers[selected].priceCents / 100));
    const offer = config.offers[selected];
    setOfferImage(document.getElementById('closing-product-image'), offer);
    document.querySelector('.closing-offer-title').textContent = offer.title;
    document.querySelector('.closing-guarantee').textContent = offer.guarantee;
    document.querySelector('.closing-gift').hidden = offer.quantity !== 3;
    const shipping = document.querySelector('.closing-shipping');
    shipping.textContent = offer.shippingCents ? shipping.dataset.paidLabel : shipping.dataset.freeLabel;
  }
  all('input[name="bundle"]').forEach(input => input.addEventListener('change', () => {
    if (cartBusy) return;
    selected = Number(input.value);
    updateBundle();
    if (bundleCart.managedLines().length) syncSelectedOffer(false);
  }));
  updateBundle();
  const imageDialog = document.querySelector('.image-dialog');
  function syncComparisonLabels(source) {
    imageDialog.querySelector('.comparison-labels')?.remove();
    const labels = source.querySelector('.comparison-labels');
    imageDialog.classList.toggle('has-comparison', Boolean(labels));
    if (labels) imageDialog.append(labels.cloneNode(true));
  }
  const gallery = root.querySelector('.gallery');
  const galleryViewport = gallery.querySelector('.gallery-viewport');
  const gallerySlides = all('.gallery-main', galleryViewport);
  const galleryThumbs = all('.gallery-thumb', gallery);
  const galleryCount = gallerySlides.length;
  let galleryIndex = 0, galleryInView = false, galleryPaused = false, galleryHovered = false;
  let galleryFocused = false, galleryTimer, galleryResumeTimer, galleryScrollFrame, gallerySettleTimer;
  let galleryPointer, suppressGalleryClickUntil = 0;
  function galleryClone(slide) {
    const clone = slide.cloneNode(true);
    clone.removeAttribute('id');
    all('[id]', clone).forEach(el => el.removeAttribute('id'));
    clone.dataset.galleryClone = 'true';
    clone.setAttribute('aria-hidden', 'true');
    clone.tabIndex = -1;
    clone.inert = true;
    const img = clone.querySelector('img');
    img.loading = 'lazy'; img.removeAttribute('fetchpriority');
    return clone;
  }
  galleryViewport.prepend(galleryClone(gallerySlides[galleryCount - 1]));
  galleryViewport.append(galleryClone(gallerySlides[0]));
  function selectGalleryImage(index) {
    galleryIndex = (index + galleryCount) % galleryCount;
    gallerySlides.forEach((slide, i) => {
      slide.tabIndex = i === galleryIndex ? 0 : -1;
      slide.setAttribute('aria-hidden', String(i !== galleryIndex));
    });
    galleryThumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === galleryIndex);
      thumb.setAttribute('aria-pressed', String(i === galleryIndex));
    });
    gallery.querySelector('.gallery-position').textContent = (galleryIndex + 1) + ' / ' + galleryCount;
    const strip = gallery.querySelector('.gallery-thumbs'), thumb = galleryThumbs[galleryIndex];
    if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({left:thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2,behavior:reduceMotion.matches ? 'instant' : 'smooth'});
  }
  function canRotateGallery() {
    return galleryInView && !galleryPaused && !galleryHovered && !galleryFocused && !document.hidden && !reduceMotion.matches && !document.querySelector('dialog[open]');
  }
  function syncGalleryTimer() {
    clearTimeout(galleryTimer);
    if (canRotateGallery()) galleryTimer = setTimeout(() => {
      if (canRotateGallery()) scrollGalleryTo(galleryIndex + 2);
      syncGalleryTimer();
    }, 5500);
  }
  function pauseGallery() {
    galleryPaused = true; clearTimeout(galleryResumeTimer); syncGalleryTimer();
    galleryResumeTimer = setTimeout(() => { galleryPaused = false; syncGalleryTimer(); }, 4000);
  }
  function scrollGalleryTo(slot) {
    galleryViewport.scrollTo({left:slot * galleryViewport.clientWidth,behavior:reduceMotion.matches ? 'instant' : 'smooth'});
  }
  function settleGallery() {
    const width = galleryViewport.clientWidth;
    if (!width) return;
    const slot = Math.round(galleryViewport.scrollLeft / width);
    if (slot === 0) galleryViewport.scrollTo({left:galleryCount * width,behavior:'instant'});
    else if (slot === galleryCount + 1) galleryViewport.scrollTo({left:width,behavior:'instant'});
    selectGalleryImage(slot - 1);
  }
  galleryViewport.addEventListener('scroll', () => {
    if (!galleryScrollFrame) galleryScrollFrame = requestAnimationFrame(() => {
      galleryScrollFrame = 0;
      const width = galleryViewport.clientWidth;
      if (width) selectGalleryImage(Math.round(galleryViewport.scrollLeft / width) - 1);
    });
    if (!('onscrollend' in galleryViewport)) {
      clearTimeout(gallerySettleTimer); gallerySettleTimer = setTimeout(settleGallery, 160);
    }
  }, {passive:true});
  galleryViewport.addEventListener('scrollend', settleGallery);
  galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => { pauseGallery(); scrollGalleryTo(index + 1); }));
  gallery.querySelector('.gallery-prev').addEventListener('click', () => { pauseGallery(); scrollGalleryTo(galleryIndex); });
  gallery.querySelector('.gallery-next').addEventListener('click', () => { pauseGallery(); scrollGalleryTo(galleryIndex + 2); });
  galleryViewport.addEventListener('keydown', event => {
    const slots = {ArrowLeft:galleryIndex,ArrowRight:galleryIndex + 2,Home:1,End:galleryCount};
    if (!(event.key in slots)) return;
    event.preventDefault(); galleryFocused = true; pauseGallery(); scrollGalleryTo(slots[event.key]);
  });
  galleryViewport.addEventListener('pointerdown', event => {
    galleryPointer = {x:event.clientX,y:event.clientY}; pauseGallery();
  }, {passive:true});
  galleryViewport.addEventListener('pointermove', event => {
    if (galleryPointer && Math.hypot(event.clientX-galleryPointer.x,event.clientY-galleryPointer.y)>8) suppressGalleryClickUntil = performance.now()+400;
  }, {passive:true});
  galleryViewport.addEventListener('pointerup', () => { galleryPointer = null; }, {passive:true});
  galleryViewport.addEventListener('pointercancel', () => { galleryPointer = null; suppressGalleryClickUntil = performance.now()+400; }, {passive:true});
  galleryViewport.addEventListener('wheel', pauseGallery, {passive:true});
  gallerySlides.forEach(slide => {
    const image = slide.querySelector('img'); image.draggable = false;
    slide.addEventListener('click', () => {
      if (performance.now() < suppressGalleryClickUntil) return;
      pauseGallery(); const img = imageDialog.querySelector('img');
      syncComparisonLabels(slide);
      img.src = image.src; img.alt = image.alt; imageDialog.showModal();
    });
  });
  gallery.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { galleryHovered = true; syncGalleryTimer(); } });
  gallery.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { galleryHovered = false; syncGalleryTimer(); } });
  gallery.addEventListener('focusin', event => { galleryFocused = event.target.matches(':focus-visible'); syncGalleryTimer(); });
  gallery.addEventListener('focusout', () => { setTimeout(() => { galleryFocused = gallery.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); syncGalleryTimer(); }, 0); });
  document.addEventListener('visibilitychange', syncGalleryTimer);
  reduceMotion.addEventListener('change', syncGalleryTimer);
  imageDialog.addEventListener('close', syncGalleryTimer);
  if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { galleryInView = entry.isIntersecting && entry.intersectionRatio >= .35; syncGalleryTimer(); }, {threshold:.35}).observe(galleryViewport);
  else galleryInView = true;
  function sizeGallery() { galleryViewport.scrollTo({left:(galleryIndex + 1) * galleryViewport.clientWidth,behavior:'instant'}); }
  if ('ResizeObserver' in window) new ResizeObserver(sizeGallery).observe(galleryViewport);
  else window.addEventListener('resize', sizeGallery, {passive:true});
  gallery.querySelector('.gallery-controls').hidden = false;
  selectGalleryImage(0); sizeGallery(); syncGalleryTimer();
  all('[data-enlarge]').forEach(button => button.addEventListener('click', () => {
    syncComparisonLabels(button);
    const img = imageDialog.querySelector('img'); img.src = button.dataset.enlarge;
    img.alt = button.querySelector('img')?.alt || button.getAttribute('aria-label') || '';
    imageDialog.showModal();
  }));
  all('.serum-select').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    if (cartBusy) return;
    const input = document.getElementById('bundle-3');
    input.checked = true; input.dispatchEvent(new Event('change', {bubbles:true}));
    document.getElementById('bundles').scrollIntoView({behavior:reduceMotion.matches ? 'instant' : 'smooth',block:'start'});
    input.focus({preventScroll:true});
    say('3 Bottles + FREE Gift selected.');
  }));
  all('dialog').forEach(dialog => {
    all('.dialog-close', dialog).forEach(b => b.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  });
  const menuButton = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  function closeMenu() { mobileNav.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); }
  menuButton.addEventListener('click', () => { const isOpen = menuButton.getAttribute('aria-expanded') === 'true'; mobileNav.hidden = isOpen; menuButton.setAttribute('aria-expanded', String(!isOpen)); });
  all('a', mobileNav).forEach(a => a.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if(event.key === 'Escape') closeMenu(); });
  const cartDialog = document.querySelector('.cart-dialog');
  const checkoutLink = document.querySelector('.checkout-link');
  function feedback(message) {
    all('.bundle-feedback,.cart-feedback,.checkout-feedback').forEach(el => { el.hidden = !message; el.textContent = message; });
    if (message) say(message);
  }
  function setCartBusy(busy) {
    cartBusy = busy;
    all('.add-to-bag,.buy-now,input[name="bundle"],.cart-remove').forEach(el => { el.disabled = busy; });
    document.querySelector('.bundle-picker').setAttribute('aria-busy', String(busy));
    document.querySelector('.closing-offer').setAttribute('aria-busy', String(busy));
    const buyButton = document.querySelector('.buy-now');
    buyButton.querySelector('.buy-now-label').textContent = busy ? buyButton.dataset.loadingLabel : buyButton.dataset.defaultLabel;
    renderBag();
  }
  function renderBag() {
    const offer = bundleCart.currentOffer();
    const populated = Boolean(offer);
    document.querySelector('.cart-empty').hidden = populated;
    document.querySelector('.cart-filled').hidden = !populated;
    const count = populated ? offer.quantity + (offer.quantity === 3 ? 1 : 0) : 0;
    document.querySelector('.cart-count').hidden = !count;
    document.querySelector('.cart-count').textContent = count;
    if (populated) {
      document.getElementById('cart-offer-title').textContent = offer.title;
      setOfferImage(document.querySelector('.cart-item>img'), offer);
      document.getElementById('cart-guarantee').textContent = offer.guarantee;
      document.querySelector('.cart-gift').hidden = offer.quantity !== 3;
      document.getElementById('cart-total').textContent = money(Number(bundleCart.cart.cost.subtotalAmount.amount));
      document.getElementById('cart-shipping-price').textContent = offer.shippingCents ? money(offer.shippingCents / 100) : 'FREE';
    }
    const ready = populated && !cartBusy && bundleCart.confirmed(offer);
    checkoutLink.setAttribute('aria-disabled', String(!ready));
    checkoutLink.tabIndex = ready ? 0 : -1;
    checkoutLink.href = ready ? bundleCart.cart.checkoutUrl : '#';
  }
  async function syncSelectedOffer(openCart, goToCheckout = false) {
    if (cartBusy) return;
    setCartBusy(true);
    feedback('Updating your bundle…');
    try {
      const offer = config.offers[selected];
      await bundleCart.setOffer(offer);
      feedback('Your bundle is ready.');
      if (goToCheckout) { window.location.assign(bundleCart.cart.checkoutUrl); return; }
      if (openCart && !cartDialog.open) cartDialog.showModal();
    } catch (error) {
      feedback(error.name === 'AbortError' ? 'Your cart is taking a little longer. Please try again.' : error.message || 'Your cart could not be updated. Please try again.');
    } finally { setCartBusy(false); }
  }
  all('.cart-toggle').forEach(button => button.addEventListener('click', () => { renderBag(); if (!cartDialog.open) cartDialog.showModal(); }));
  all('.add-to-bag').forEach(button => button.addEventListener('click', () => syncSelectedOffer(true)));
  document.querySelector('.buy-now').addEventListener('click', () => syncSelectedOffer(false, true));
  document.querySelector('.cart-remove').addEventListener('click', async () => {
    if (cartBusy) return;
    setCartBusy(true);
    try { await bundleCart.remove(); feedback('Your bundle has been removed.'); }
    catch (error) { feedback('Your bundle could not be removed. Please try again.'); }
    finally { setCartBusy(false); }
  });
  checkoutLink.addEventListener('click', event => {
    if (checkoutLink.getAttribute('aria-disabled') === 'true') event.preventDefault();
  });
  if (bundleCart.id) {
    setCartBusy(true);
    bundleCart.load().then(() => {
      const offer = bundleCart.currentOffer();
      if (offer) {
        selected = offer.quantity;
        const input = document.querySelector('input[name="bundle"][value="' + selected + '"]');
        if (input) input.checked = true;
        updateBundle();
      }
    }).catch(() => feedback('Your cart could not be loaded. Please try again.')).finally(() => setCartBusy(false));
  }
  const survey = config.survey;
  ['sampleSize', 'period'].forEach((key, i) => { document.getElementById(['survey-sample', 'survey-period'][i]).textContent = survey[key]; });
  const hasValidPercentage = value => typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 100;
  all('[data-result]').forEach(column => {
    const result = survey[column.dataset.result];
    column.querySelector('h3').textContent = result.outcome;
    column.querySelector('.result-support').textContent = result.supporting;
    const label = column.querySelector('.result-number');
    const number = column.querySelector('[data-counter]');
    if (hasValidPercentage(result.percentage)) {
      number.dataset.target = result.percentage;
      number.textContent = result.percentage;
      label.setAttribute('aria-label', result.percentage + '% ' + result.outcome.replaceAll('\n', ' '));
    } else {
      number.textContent = '—';
      const placeholders = {balance: '[BALANCE RESULT %]', digestion: '[DIGESTION RESULT %]', rested: '[RESTED RESULT %]'};
      label.setAttribute('aria-label', placeholders[column.dataset.result]);
    }
  });
  // One observer handles the editorial reveals and the survey count-up.
  // Content is visible without JavaScript, and no animation library is loaded.
  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = 'true';
    const target = Number(el.dataset.target);
    if (reduceMotion.matches) { el.textContent = target; return; }
    const start = performance.now(), duration = 700;
    const decimals = Number.isInteger(target) ? 0 : 1;
    function frame(time) {
      if (reduceMotion.matches) { el.textContent = target; return; }
      const progress = Math.min((time - start) / duration, 1);
      el.textContent = (target * (1 - Math.pow(1 - progress, 3))).toFixed(decimals);
      if (progress < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  all('.formula-copy,.outcome-copy,.label-copy,.faq-list').forEach(el => el.classList.remove('reveal'));
  const revealSelectors = [
    '.customer-review-summary','.customer-review-entry','.hero-expert','.bundle-picker','.hero-guarantee','.hero-customer-trust','.product-accordions',
    '.serum-heading','.serum-overview','.serum-directions>div','.serum-select','.trust-grid>span',
    '.formula-copy>.eyebrow','.formula-copy>h2','.formula-copy>.section-intro','.formula-points>div','.formula-copy>.text-link',
    '.outcome-copy>p','.outcome-copy>h2','.survey-source','.story-carousel',
    '.label-copy>.eyebrow','.label-copy>h2','.label-copy>.section-intro','.supplement-facts','.ingredients-copy','.label-caution',
    '.faq-list>details','.guarantee-copy>.eyebrow','.guarantee-copy>h2','.guarantee-intro','.guarantee-description',
    '.guarantee-terms','.guarantee-copy>.button','.guarantee-policy','.guarantee-visual','.footer-top','.footer-bottom'
  ];
  all(revealSelectors.join(',')).forEach(el => el.classList.add('reveal'));
  ['.trust-grid>span','.benefit-tile','.faq-list>details'].forEach(selector => {
    all(selector).forEach((el,i) => el.style.setProperty('--reveal-delay', Math.min(i * 80, 240) + 'ms'));
  });
  let revealObserver;
  if ('IntersectionObserver' in window) {
    const revealItems = all('.reveal');
    if (!reduceMotion.matches) {
      root.classList.add('motion-enabled');
      // Batch geometry reads before class writes to avoid forced relayout.
      const belowFold = revealItems.filter(el => el.getBoundingClientRect().top >= window.innerHeight);
      belowFold.forEach(el => el.classList.add('is-unseen'));
      all('[data-counter][data-target]').forEach(el => { el.textContent = '0'; });
    }
    revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('is-unseen');
      const counter = entry.target.querySelector('[data-counter][data-target]');
      if (counter) {
        const delay = reduceMotion.matches ? 0 : parseFloat(getComputedStyle(entry.target).transitionDelay) * 1000;
        setTimeout(() => countUp(counter), Number.isFinite(delay) ? delay : 0);
      }
      revealObserver.unobserve(entry.target);
    }), {threshold:.08,rootMargin:'0px 0px -20px 0px'});
    revealItems.forEach(el => revealObserver.observe(el));
    const sticky = document.querySelector('.sticky-shop');
    const stickyObserver = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, {threshold:0});
    stickyObserver.observe(document.getElementById('primary-add'));
  }
  reduceMotion.addEventListener('change', () => {
    if (reduceMotion.matches) {
      root.classList.remove('motion-enabled');
      all('.is-unseen').forEach(el => el.classList.remove('is-unseen'));
      all('[data-counter][data-target]').forEach(el => { el.textContent = el.dataset.target; });
    }
  });
  const outcomeVideo = root.querySelector('.outcome-video');
  if (outcomeVideo) {
    let videoInView = false;
    outcomeVideo.defaultMuted = true;
    outcomeVideo.muted = true;
    outcomeVideo.loop = true;
    outcomeVideo.controls = false;
    outcomeVideo.playsInline = true;
    function syncVideo() {
      if (document.hidden || !videoInView || reduceMotion.matches) {
        outcomeVideo.pause(); return;
      }
      outcomeVideo.play().catch(() => {});
    }
    outcomeVideo.addEventListener('loadeddata', syncVideo);
    outcomeVideo.addEventListener('canplay', syncVideo);
    outcomeVideo.addEventListener('playing', () => { if (document.hidden || !videoInView || reduceMotion.matches) outcomeVideo.pause(); });
    outcomeVideo.addEventListener('ended', syncVideo);
    root.addEventListener('pointerup', syncVideo, {passive:true});
    reduceMotion.addEventListener('change', syncVideo);
    document.addEventListener('visibilitychange', syncVideo);
    window.addEventListener('pageshow', syncVideo);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { videoInView = entry.isIntersecting && entry.intersectionRatio >= .1; syncVideo(); }, {threshold:[0,.1]}).observe(outcomeVideo);
    } else { videoInView = true; syncVideo(); }
    syncVideo();
  }
  const weekStages = all('.week-stage');
  if (weekStages.length) {
    let weeksInView = false, frameQueued = false, listening = false;
    const markers = weekStages.map(stage => stage.querySelector('.week-marker'));
    function updateWeeks() {
      frameQueued = false;
      const progress = weekStages.map((stage,i) => {
        if (reduceMotion.matches) return 1;
        const rect = stage.getBoundingClientRect(), marker = markers[i].getBoundingClientRect();
        return Math.max(0, Math.min(1, (window.innerHeight * .76 - marker.top - marker.height / 2) / Math.max(1, rect.height)));
      });
      weekStages.forEach((stage,i) => stage.style.setProperty('--week-progress', progress[i].toFixed(4)));
    }
    function scheduleWeeks() {
      if (!frameQueued && weeksInView) { frameQueued = true; requestAnimationFrame(updateWeeks); }
    }
    function syncWeeks() {
      const shouldListen = weeksInView && !reduceMotion.matches;
      if (shouldListen !== listening) {
        listening = shouldListen;
        const method = listening ? 'addEventListener' : 'removeEventListener';
        window[method]('scroll', scheduleWeeks, {passive:true});
        window[method]('resize', scheduleWeeks, {passive:true});
      }
      if (weeksInView || reduceMotion.matches) updateWeeks();
    }
    reduceMotion.addEventListener('change', syncWeeks);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { weeksInView = entry.isIntersecting; syncWeeks(); }, {rootMargin:'100px 0px'}).observe(root.querySelector('.weeks-section'));
    } else { weeksInView = true; syncWeeks(); }
  }
  const carousel = document.querySelector('.story-carousel');
  const track = carousel.querySelector('.story-track');
  const slides = all('.story-slide');
  let slideIndex = 0, manualPaused = false, hovering = false, hasFocus = false, inView = false, timer, storyResumeTimer;
  const interval = 8500;
  function setSlide(index) {
    slideIndex = (index + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + slideIndex * 100 + '%)';
    slides.forEach((slide, i) => { slide.inert = i !== slideIndex; slide.setAttribute('aria-hidden', String(i !== slideIndex)); });
    all('.story-dot').forEach((dot,i) => { dot.classList.toggle('active', i === slideIndex); dot.setAttribute('aria-pressed', String(i === slideIndex)); });
    carousel.querySelector('.story-position').textContent = String(slideIndex + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
  }
  function syncTimer() {
    clearInterval(timer);
    const paused = manualPaused || hovering || hasFocus || !inView || document.hidden || reduceMotion.matches;
    if (!paused) timer = setInterval(() => setSlide(slideIndex + 1), interval);
  }
  function manualSlide(index) {
    manualPaused = true; clearTimeout(storyResumeTimer); setSlide(index); syncTimer();
    storyResumeTimer = setTimeout(() => { manualPaused = false; syncTimer(); }, 4000);
  }
  carousel.querySelector('.story-prev').addEventListener('click', () => manualSlide(slideIndex - 1));
  carousel.querySelector('.story-next').addEventListener('click', () => manualSlide(slideIndex + 1));
  all('.story-dot').forEach(dot => dot.addEventListener('click', () => manualSlide(Number(dot.dataset.slide))));
  carousel.addEventListener('mouseenter', () => { hovering = true; syncTimer(); });
  carousel.addEventListener('mouseleave', () => { hovering = false; syncTimer(); });
  carousel.addEventListener('focusin', event => { hasFocus = event.target.matches(':focus-visible'); syncTimer(); });
  carousel.addEventListener('focusout', () => { setTimeout(() => { hasFocus = carousel.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); syncTimer(); }, 0); });
  document.addEventListener('visibilitychange', syncTimer);
  reduceMotion.addEventListener('change', syncTimer);
  let touchStart;
  carousel.addEventListener('touchstart', event => {
    const touch = event.changedTouches[0];
    touchStart = {x:touch.clientX,y:touch.clientY};
  }, {passive:true});
  carousel.addEventListener('touchend', event => {
    if (!touchStart) return;
    const touch = event.changedTouches[0];
    const dx = touchStart.x - touch.clientX, dy = touchStart.y - touch.clientY;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) manualSlide(slideIndex + (dx > 0 ? 1 : -1));
    touchStart = null;
  }, {passive:true});
  carousel.addEventListener('touchcancel', () => { touchStart = null; }, {passive:true});
  if ('IntersectionObserver' in window) { new IntersectionObserver(([entry]) => { inView = entry.isIntersecting; syncTimer(); }, {threshold:.15}).observe(carousel); } else { inView = true; }
  setSlide(0); syncTimer();
})();


  } catch(e) { console.error(e); }
})();
})();
